import IBloc from "../../base/IBloc";
import i18n from "i18next";
import LocalStorage from "../../base/LocalStorage";

export class BlocAppWrapper extends IBloc {
    blocParent: any
    blocChild: any
    visSetting: any = {}
    conSetting: any = {}
    public system: any = {}
    langData: any = null

    init() {
        super.init();
        this._blocData['handleRequest'] = {}
    }

    async loadInit() {
        const langKey = LocalStorage.getItem("i18nextLng") ?? 'vi'
        
        // For now, we'll simplify the initialization
        // In a real implementation, you would load language data from your API
        try {
            // Placeholder for language loading
            // You can implement actual API calls here when you have your language API ready
            console.log(`Initializing app with language: ${langKey}`);
            
            this.setStream("loadInit", { 
                loginRequire: { status: 0, url: "" }, 
                finish: true 
            });
        } catch (error) {
            console.error('Error during app initialization:', error);
            this.setStream("loadInit", { 
                loginRequire: { status: -1, url: "" }, 
                finish: true,
                error: error 
            });
        }
    }

    showAlert(info: AlertProps, onCallBack?: { (action: any): void } | null, onHideCallBack?: { (): void } | null) {
        info.label = info.label ?? 'close'
        info.title = info.title ?? 'title'
        info.message = info.message ?? 'message'
        info.type = info?.type ?? 0
        info.dismissableMask = info?.dismissableMask ?? true
        if (!info.onHide) {
            info.onHide = (action) => {
                this.onHide(action)
            }
        }
        info.isShow = true
        info.onCallBack = onCallBack
        info.onHideCallBack = onHideCallBack
        this.setStream('dialogAlert', info)
    }

    showAlertApi(message: string, onCallBack?: { (action: any): void } | null, onHideCallBack?: { (): void } | null) {
        const info: AlertProps = { title: 'error', label: 'close' }

        info.message = message
        info.type = info?.type ?? 0
        info.dismissableMask = info?.dismissableMask ?? true
        if (!info.onHide) {
            info.onHide = (action) => {
                this.onHide(action)
            }
        }
        info.isShow = true
        info.label = 'close'
        info.onCallBack = onCallBack
        info.onHideCallBack = onHideCallBack
        this.setStream('dialogAlert', info)
    }

    showAlertError(message: string, label: string = 'close', onCallBack?: { (action: any): void } | null, onHideCallBack?: { (): void } | null) {
        const info: AlertProps = { title: 'error', label: 'close' }

        info.message = message
        info.type = info?.type ?? 0
        info.dismissableMask = info?.dismissableMask ?? true
        if (!info.onHide) {
            info.onHide = (action) => {
                this.onHide(action)
            }
        }
        info.label = label
        info.isShow = true
        info.onCallBack = onCallBack
        info.onHideCallBack = onHideCallBack
        this.setStream('dialogAlert', info)
    }

    showConfirm(info: ConfirmProps, onCallBack?: { (action: any): void } | null, onHideCallBack?: { (): void } | null) {
        info.labelNo = info.labelNo ?? 'no'
        info.labelYes = info.labelYes ?? 'yes'
        info.title = info.title ?? 'title'
        info.message = info.message ?? 'message'
        info.type = info.type ?? 1
        info.dismissableMask = info.dismissableMask ?? false
        if (!info.onHide) {
            info.onHide = (action) => {
                this.onHide(action)
            }
        }
        info.isShow = true
        info.onCallBack = onCallBack
        info.onHideCallBack = onHideCallBack
        this.setStream('dialogConfirm', info)
    }

    private onHide(action: DialogBase) {
        if (action) {
            action.isShow = false
            switch (action.type) {
                case 1:
                    this.setStream('dialogConfirm', action)
                    break
                case 0:
                    this.setStream('dialogAlert', action)
                    break
                default:
                    this.setStream('dialogAlert', action)
            }
            action.onHideCallBack?.()
        }
    }

    // Helper methods for language and settings management
    setLanguage(langKey: string) {
        LocalStorage.setItem("i18nextLng", langKey);
        i18n.changeLanguage(langKey);
    }

    getLanguage(): string {
        return LocalStorage.getItem("i18nextLng") ?? 'vi';
    }

    setSetting(key: string, value: any) {
        this.visSetting[key] = value;
        LocalStorage.setItem(`setting_${key}`, JSON.stringify(value));
    }

    getSetting(key: string, defaultValue?: any): any {
        if (this.visSetting[key] !== undefined) {
            return this.visSetting[key];
        }
        
        const stored = LocalStorage.getItem(`setting_${key}`);
        if (stored) {
            try {
                return JSON.parse(stored);
            } catch {
                return stored;
            }
        }
        
        return defaultValue;
    }
}

export interface DialogBase {
    type?: number | 0
    title?: string | ''
    message?: string | ''
    onCallBack?: { (action: any): void } | null
    onHideCallBack?: { (): void } | null
    onHide?: { (action: any): void }
    dismissableMask?: boolean | true
    isShow?: boolean | true
}

export interface AlertProps extends DialogBase {
    label?: string
}

export interface ConfirmProps extends DialogBase {
    labelNo?: string
    labelYes?: string
}
